export const PAGE_PERFORMANCE_AUDIT_IMPACT = {
    LOW: 1,
    MEDIUM: 2,
    HIGH: 3,
} as const;
